/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useLoader } from 'react-three-fiber'
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
// import texture1 from '../assets/sideboards/1.jpg'
// import texture2 from '../assets/sideboards/2.jpg'
// import texture3 from '../assets/sideboards/4.jpg'
// import texture4 from '../assets/sideboards/4.jpg'
// import texture5 from '../assets/sideboards/5.jpg'
// import texture6 from '../assets/sideboards/6.jpg'

type GLTFResult = GLTF & {
  nodes: {
    Sideboard: THREE.Mesh
  }
  materials: {
    Sideboard_glTF: THREE.MeshStandardMaterial
  }
}

type Props = {
  number: number;
}

export default function Model(props: Props & JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>()
  const { nodes, materials } = useLoader<GLTFResult>(GLTFLoader, `/assets/Sideboards/0${props.number}/Sideboards.gltf?number=${props.number}`)

  return (
    <group name={`Sideboard ${props.number}`} ref={group} {...props} dispose={null}>
      <mesh castShadow  receiveShadow scale={[10, 10, 10]} material={materials.Sideboard_glTF} geometry={nodes.Sideboard.geometry} />
    </group>
  )
}
